import { atom } from 'recoil';

export const placeOrderAtom = atom<boolean>({
  key: 'placeOrderAtom',
  default: false,
});
